import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  // 顧客のボトル一覧を取得
  getCustomerBottles(customerId) {
    return axiosIns.get(`/waiter/customers/${customerId}/customer_bottles`)
  },

  // ボトル詳細を取得
  getCustomerBottle(bottleId) {
    return axiosIns.get(`/waiter/customer_bottles/${bottleId}`)
  },

  // ボトルを作成
  createCustomerBottle(customerId, customerBottle) {
    return axiosIns.post(
      `/waiter/customers/${customerId}/customer_bottles`,
      snakecaseKeys({ customerBottle }),
    )
  },

  // ボトルを更新
  updateCustomerBottle(bottleId, customerBottle) {
    return axiosIns.put(
      `/waiter/customer_bottles/${bottleId}`,
      snakecaseKeys({ customerBottle }),
    )
  },

  // ボトルを削除（論理削除）
  deleteCustomerBottle(bottleId) {
    return axiosIns.delete(`/waiter/customer_bottles/${bottleId}`)
  },
}
